import { useApp } from 'context/AppContext';
import { Goods } from 'components';
import { Button } from 'styles/AppStyles';
import { Container, Title } from './Styles';

const DailyBonus = ({ data }) => {
  const { closeModal } = useApp();
  const { gLt } = data;

  return (
    <Container>
      <Goods goods={gLt} withStyle />
      <Title>Rewards added to your balance!</Title>
      <Button $isModal onClick={() => closeModal()}>
        ROLL ON!
      </Button>
    </Container>
  );
};

export default DailyBonus;
